import { Link } from "react-router-dom";
import { ArrowLeft, FileSearch } from "lucide-react";

export default function TermsOfUse() {
  return (
    <div className="min-h-screen bg-white" data-testid="terms-of-use-page">
      <nav className="border-b border-slate-200 bg-white">
        <div className="section-container flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2.5" data-testid="terms-logo-link">
            <div className="w-8 h-8 rounded-lg overflow-hidden">
              <img src="https://customer-assets.emergentagent.com/job_bid-quality/artifacts/plxbtywa_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202026-03-12%20%D0%B2%2019.39.09.png" alt="AICallFront" className="w-full h-full object-cover" />
            </div>
            <span className="font-heading text-lg font-bold text-[#0F172A] tracking-tight">AICallFront</span>
          </Link>
          <Link to="/" className="flex items-center gap-2 text-sm text-slate-600 hover:text-[#0F172A] transition-colors" data-testid="terms-back-link">
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Link>
        </div>
      </nav>

      <main className="section-container py-16 md:py-24 max-w-3xl">
        <h1 className="font-heading text-3xl md:text-4xl font-bold text-[#0F172A] tracking-tight mb-8">Terms of Use</h1>
        <p className="text-sm text-slate-500 mb-8">Last updated: December 2025</p>

        <div className="prose prose-slate max-w-none space-y-6 text-slate-600 leading-relaxed">
          <h2 className="font-heading text-xl font-semibold text-[#0F172A] mt-8">1. Acceptance of Terms</h2>
          <p>By accessing and using the AICallFront platform at aicallfront.com, you agree to be bound by these Terms of Use. If you do not agree to these terms, please do not use our services.</p>

          <h2 className="font-heading text-xl font-semibold text-[#0F172A] mt-8">2. Description of Services</h2>
          <p>AICallFront provides an AI-powered voice and chat receptionist platform for small businesses. Our services include automated call answering, lead capture, calendar integration, appointment booking, and conversation summaries for staff.</p>

          <h2 className="font-heading text-xl font-semibold text-[#0F172A] mt-8">3. User Obligations</h2>
          <p>When using our platform, you agree to:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Provide accurate and complete business information when signing up</li>
            <li>Use the platform only for lawful purposes related to business communications</li>
            <li>Not attempt to reverse-engineer, copy, or redistribute our technology</li>
            <li>Not use the platform for spam, harassment, or fraudulent activities</li>
            <li>Maintain the confidentiality of your account information</li>
          </ul>

          <h2 className="font-heading text-xl font-semibold text-[#0F172A] mt-8">4. Intellectual Property</h2>
          <p>All content, features, and functionality of the AICallFront platform are owned by AICallFront and are protected by international copyright, trademark, and other intellectual property laws. Your business data and call recordings remain your property.</p>

          <h2 className="font-heading text-xl font-semibold text-[#0F172A] mt-8">5. Limitation of Liability</h2>
          <p>AICallFront provides AI-powered call handling and appointment booking as automation tools. Our platform does not guarantee the accuracy of every AI response or booking. Final oversight of customer interactions remains the sole responsibility of the business owner. AICallFront shall not be liable for any losses arising from AI-handled interactions.</p>

          <h2 className="font-heading text-xl font-semibold text-[#0F172A] mt-8">6. Confidentiality</h2>
          <p>We treat all business data, call recordings, and customer information processed through our platform as confidential. We will not share your data with third parties without your explicit consent, except as required by law.</p>

          <h2 className="font-heading text-xl font-semibold text-[#0F172A] mt-8">7. Termination</h2>
          <p>We reserve the right to suspend or terminate access to our services at any time if these Terms of Use are violated, or for any other reason at our sole discretion.</p>

          <h2 className="font-heading text-xl font-semibold text-[#0F172A] mt-8">8. Governing Law</h2>
          <p>These Terms of Use shall be governed by and construed in accordance with the laws of England and Wales. Any disputes shall be subject to the exclusive jurisdiction of the courts of England and Wales.</p>

          <h2 className="font-heading text-xl font-semibold text-[#0F172A] mt-8">9. Contact</h2>
          <p>For questions regarding these Terms, contact us at:</p>
          <p>AICallFront<br />22 Tudor Street, City of London<br />London EC4Y 0AY, UK<br />Email: info@aicallfront.com<br />Phone: +44 20 3917 2500</p>
        </div>
      </main>
    </div>
  );
}
